import { MadisonLogo } from "@/components/shared/madison-logo";
import { ThemeToggle } from "./ThemeToggle";

/**
 * Sign-in, sign-up and "sign-up closed" share this: MESH 1's look, a plain page with
 * Madison's logo centred above the form and the product name under it.
 */
export function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-card dark:bg-background">
      <div className="flex justify-end p-4">
        <ThemeToggle />
      </div>

      <div className="flex flex-1 flex-col items-center px-4 pb-12 sm:justify-center sm:pb-24">
        <div className="w-full max-w-sm">
          <div className="mb-8 flex flex-col items-center gap-3 text-center">
            <MadisonLogo className="h-12 max-w-full sm:h-14" />
            <p className="font-display text-lg font-semibold tracking-wide text-foreground">
              Photo Portal
            </p>
          </div>
          {children}
        </div>
      </div>

      <p className="px-4 pb-6 text-center text-xs text-muted-foreground">
        MESH Photo Portal · Madison Energy Infrastructure
      </p>
    </div>
  );
}
